<script lang="ts">
    import { onMount } from "svelte";
    import { Link, useNavigate } from "svelte-navigator";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { networkStore } from "../../../../store/networks";
    import { user } from "../../../../store/stores";
    import { organisationStore } from "../../../../store";
    import NetworkCard from "./Components/NetworkCard.svelte";
    import Pagination from "./Components/Pagination.svelte";

    const navigate = useNavigate();

    const getNetworks = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .networkClient.listNetworks({
                    size: 17,
                    ...($organisationStore.activeOrgaId && {
                        contextOrganisation: $organisationStore.activeOrgaId,
                    }),
                })
                .then((networks) =>
                    networkStore.update((networkStore) => {
                        return {
                            ...networkStore,
                            networks: networks,
                        };
                    })
                );
        });
    };

    onMount(() => getNetworks());
</script>

<div class="columns is-multiline">
    <div class="column is-12">
        <div class="card sticky">
            <div class="card-content">
                <div class="content">
                    <div class="columns is-vcentered is-multiline">
                        <div class="column is-2">
                            <p
                                class="is-5 greenish-plus"
                                on:click={() => navigate("new")}
                            >
                                +
                            </p>
                        </div>
                        <div class="column is-3 ">
                            <p class="is-5 greenish">Netz</p>
                        </div>
                        <div class="column is-3 ">
                            <p class="greenish is-5">Status</p>
                        </div>
                        <div class="column is-3">
                            <p class="greenish is-5">Standorte</p>
                        </div>
                        {#if $networkStore.networks && $networkStore.networks.entries}
                            {#each $networkStore.networks.entries as network}
                                <NetworkCard {network} />
                            {/each}
                        {/if}
                        {#if $networkStore.networks && $networkStore.networks.entries}
                            <Pagination />
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .sticky {
        position: sticky;
        top: 0rem;
        z-index: 100;
    }

    .column {
        text-align: center;
    }

    .card {
        border-radius: 100px;
        padding: 1rem;
        padding-bottom: 0;
    }

    .greenish {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        margin: 0 11px;
        padding: 13px;
    }

    .greenish-plus {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        width: 50px;
        margin: auto;
        padding: 13px;
        font-size: 2rem;
        font-weight: 600;
        line-height: 25px;
    }

    .greenish-plus:hover {
        cursor: pointer;
    }
</style>
